import { Injectable, NgZone } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ZoneService {

	// TODO: Export to a separate package

	constructor(private ngZone: NgZone) { }

	public run(fn: () => void): any {
		const result = NgZone.isInAngularZone()
			? fn()
			: this.ngZone.run(() => fn());

		return result;
	}
}
